import { MHC_CODE } from '@utils/constants/medicalCodes';
import { convertActiveStatusToYesNoUnknown } from '@utils';

const transformBulkMHCDataSearch = (data) => {
  if (!data || data.length === 0) return {};

  // "Medical history - patient reported" section
  return Object.values(MHC_CODE).reduce((acc, property) => {
    const foundData = data.find((d) => d.code?.coding?.code === property);
    if (!foundData) return acc;
    return {
      ...acc,
      [property]: {
        id: foundData?.id,
        code: foundData?.code?.coding?.code,
        diagnoseDate: foundData?.recordedDate ?? null, // This is still needed (pulling from `transformMedicalHistory`)
        display: foundData?.code?.coding?.display ?? '',
        patientId: foundData?.patientId,
        status: foundData?.status ?? null,
        unit: null,
        updatedAt: foundData?.updatedDate ?? foundData?.updatedAt ?? null,
        value: convertActiveStatusToYesNoUnknown(foundData?.status) ?? null,
      },
    };
  }, {});
};

export default transformBulkMHCDataSearch;
